<template>
    <footer class="footer" v-if="data">
        <Newsletter :content="data.newsletter" />

        <div class="inner">
            <nav class="footer-menus">
                <div class="column">
                    <div class="item">
                        <h3>
                            <Link :link="data.menus[0].menu.title" v-html="data.menus[0].menu.title.title"></Link>
                        </h3>
                        <ul>
                            <li v-for="(item, index) in data.menus[0].menu.items" :key="index">
                                <Link :link="item.link">
                                    <span v-html="item.link.title"></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="column">
                    <div class="item">
                        <h3>
                            <Link :link="data.menus[1].menu.title" v-html="data.menus[1].menu.title.title"></Link>
                        </h3>
                        <ul>
                            <li v-for="(item, index) in data.menus[1].menu.items" :key="index">
                                <Link :link="item.link">
                                    <span v-html="item.link.title"></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="column">
                    <div class="item">
                        <h3>
                            <Link :link="data.menus[2].menu.title" v-html="data.menus[2].menu.title.title"></Link>
                        </h3>
                        <ul>
                            <li v-for="(item, index) in data.menus[2].menu.items" :key="index">
                                <Link :link="item.link">
                                    <span v-html="item.link.title"></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div class="item">
                        <h3>
                            <Link :link="data.menus[3].menu.title" v-html="data.menus[3].menu.title.title"></Link>
                        </h3>
                        <ul>
                            <li v-for="(item, index) in data.menus[3].menu.items" :key="index">
                                <Link :link="item.link">
                                    <span v-html="item.link.title"></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="column">
                    <div class="item">
                        <h3>
                            <Link :link="data.menus[4].menu.title" v-html="data.menus[4].menu.title.title"></Link>
                        </h3>
                        <ul>
                            <li v-for="(item, index) in data.menus[4].menu.items" :key="index">
                                <Link :link="item.link">
                                    <span v-html="item.link.title"></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div class="item">
                        <h3>
                            <Link :link="data.menus[5].menu.title" v-html="data.menus[5].menu.title.title"></Link>
                        </h3>
                        <ul>
                            <li v-for="(item, index) in data.menus[5].menu.items" :key="index">
                                <Link :link="item.link">
                                    <span v-html="item.link.title"></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="column">
                    <div class="item">
                        <h3>
                            <Link :link="data.menus[6].menu.title" v-html="data.menus[6].menu.title.title"></Link>
                        </h3>
                        <ul>
                            <li v-for="(item, index) in data.menus[6].menu.items" :key="index">
                                <Link :link="item.link">
                                  <span v-html="item.link.title"></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                    <div class="item">
                        <h3>
                            <Link :link="data.menus[7].menu.title" v-html="data.menus[7].menu.title.title"></Link>
                        </h3>
                        <ul>
                            <li v-for="(item, index) in data.menus[7].menu.items" :key="index">
                                <Link :link="item.link">
                                    <span v-html="item.link.title"></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <div class="btn">
                <Button :color="'white'" :size="'large'" @click.native="backTop">↑ Back to top</Button>
            </div>
        </div>

        <div class="links">
            <ul>
                <li>
                    <div>
                        <Link :link="data.instagram_url">⊖</svg>
                        </Link>
                        <Link :link="data.facebook_url">⊕</svg>
                        </Link>
                        <Link :link="data.twitter_url">⊗</svg>
                        </Link>
                    </div>
                </li>
                <li>
                    <Link :link="data.shop_url">
                        <span v-html="data.shop_url.title"></span>
                    </Link>
                </li>
                <li>
                    <Link :link="data.support_url">
                        <span v-html="data.support_url.title"></span>
                    </Link>
                </li>
                <li>
                	<Link>
                    	<span @click="open">STAY IN TOUCH</span>
                    </Link>
                </li>
            </ul>
        </div>

        <div class="inner">
            <div class="bottom">
                <p v-html="data.copyright"></p>
                <ul>
                    <li v-for="(item, index) in data.bottom_menu" :key="index">
                        <Link :post_link="item.post_link">
                            <span v-html="item.post_title"></span>
                        </Link>
                    </li>
                    <li><a href="https://kellenberger-white.com" target="_blank">Brand identity: Kellenberger–White</a></li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script>
// import '@/assets/svg/instagram.svg?sprite';
// import '@/assets/svg/facebook.svg?sprite';
// import '@/assets/svg/twitter.svg?sprite';

import Newsletter from '@/components/Newsletter.vue';
import Button from '@/components/ui/Button.vue';
import Link from '@/components/ui/Link.vue';

import { EventBus } from '@/events/bus.js';

export default {
    name: 'site-footer',

    components: {
      Newsletter,
      Button,
      Link,
    },

    data() {
        return {
            data: '',
        }
    },

    methods: {
        backTop() {
            this.$smoothScroll({
                scrollTo: window.document.body,
                duration: 500,
            });
        },

        open() {
            EventBus.$emit('newsletter.open');
        },
    },

    mounted() {
        this.$ajax.get('/footer').then(res => {
            this.data = res.data;

            res.data.menus.forEach(function(menuItem){
              menuItem.show_sub_menu = false;

              if(process.env.NODE_ENV === 'development') {
                const items = Array.from(menuItem.menu.items)
                items.forEach(function(item){
                  // console.log(item.link)
                  item.link.url = item.link.url.replace(window.globals.live_url, '')
                })
              }
            });

            this.$store.state.menus = res.data.menus;
            this.$store.state.ticket_link = res.data.ticket_link;
            this.$store.state.cookies = res.data.cookies;
            this.$store.state.notification = res.data.notification;
            this.$store.state.link = res.data.link;
            this.$store.state.text = res.data.text;
        });
    },
}
</script>
<style lang="scss">
    .footer {
        color: white;
        background-color: black;
        position: relative;
        z-index: 9;
        font-size: var(--small-size);
        overflow: hidden;

        a,
        a:hover,
        a:visited,
        a:active {
            color: white;
        }

        .footer-menus {
            margin: var(--padding-x2) auto;
            display: flex;
            padding: 0 4.5rem;

            .column {
                width: 20%;
            }

            .item {
                margin: 0 0 var(--padding) 0;

                h3 {
                    margin: 0 0 var(--padding-50) 0;
                    font-size: var(--base-size);
                }
            }
        }

        .btn {
            margin: var(--padding-x2) 0;
            text-align: center;

            .ui-button {
                cursor: pointer;
            }
        }

        .bottom {
            display: flex;
            margin: var(--padding) 0;

            & > p {
                flex: 1;
            }

            & > ul {
                display: flex;

                li {
                    padding-left: var(--padding-50);
                }
            }
        }

        .links {
            margin: var(--padding-x3) 0;

            ul {
                display: flex;
                justify-content: center;
                margin: var(--padding) 0;
            }

            li {
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 1;
                width: 30rem;
                height: 30rem;
                border-radius: 50%;
                box-sizing: border-box;
                border: 2px solid;
                transition: width .2s ease-in-out;

                &:hover {
                    width: 40rem;
                }


                & > div {
                    display: flex;
                    font-size: var(--medium-size);

                    svg {
                        height: 3rem;
                        width: 3rem;
                        margin: 0 .75rem;
                    }

                    a {
                        margin: 0 .75rem;
                    }
                }

                & > a {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    width: 100%;
                    font-size: var(--medium-size);
                    text-transform: uppercase;
                    text-align:center;
                    color: var(--footer-1);

                    & > span {
                      max-width: 72%;
                    }
                }
            }

            li:nth-child(1) {
                color: var(--footer-1);
            }

            li:nth-child(2) {
                color: var(--footer-2);

                a,
                a:hover,
                a:visited,
                a:active {
                    color: var(--footer-2);
                }
            }

            li:nth-child(3) {
                color: var(--footer-3);

                a,
                a:hover,
                a:visited,
                a:active {
                    color: var(--footer-3);
                }
            }

            li:nth-child(4) {
            	display: none;
            }
        }
    }

    html.theme-color-1 {
        body.type-ideas,
        body.body-class-ideas,
        body.type-stories,
        body.page-single-stories,
        body.type-in-focus,
        body.page-single-object,
        body.page-peoples,
        body.page-single-people {
            .footer {
                background: black !important;
                color: white !important;
                .newsletter {
                    display: none;
                }
                a,a:hover,a:visited,a:active {
                    color: white !important;
                }
                .ui-button.color-white {
                    color: white !important;
                    border-color: white !important;
                    &:hover {
                        color: black !important;
                        background: white !important;
                    }
                }
                .links {
                    li {
                        color: var(--theme-1-color-3) !important;
                    }
                    li:nth-child(3) {
                        display: none;
                    }
                    li:nth-child(4) {
                        display: flex;
                    }
                    a {
                        color: var(--theme-1-color-3) !important;
                    }
                }
            }
        }
    }

    html.theme-color-2 {
        body.type-ideas,
        body.body-class-ideas,
        body.type-stories,
        body.page-single-stories,
        body.type-in-focus,
        body.page-single-object,
        body.page-peoples,
        body.page-single-people {
            .footer {
                background: black !important;
                color: white !important;
                .newsletter {
                    display: none;
                }
                a,a:hover,a:visited,a:active {
                    color: white !important;
                }
                .ui-button.color-white {
                    color: white !important;
                    border-color: white !important;
                    &:hover {
                        color: black !important;
                        background: white !important;
                    }
                }
                .links {
                    li {
                        color: var(--theme-2-color-3) !important;
                    }
                    li:nth-child(3) {
                        display: none;
                    }
                    li:nth-child(4) {
                        display: flex;
                    }
                    a {
                        color: var(--theme-2-color-3) !important;
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 767px) {


        .footer {
            font-size: var(--base-size);


            .footer-menus {
                padding: 0;
                margin: 0;
                flex-wrap: wrap;
                display: none;

                .column {
                    width: 50%;
                    padding: var(--padding) 0;
                    box-sizing: border-box;
                }

                .item {
                    h3 {
                        font-size: var(--medium-size);
                    }
                }
            }


            .bottom {
                display: block;
                padding: 0;
                font-size: var(--small-size);

                & > ul {
                    display: block;
                    padding-top: var(--padding);

                    li {
                        padding-left: 0;
                        padding-right: var(--padding);
                        display: inline-block;
                    }
                }
            }

            .links {


                li {

                    border-width: 1px;

                    & > div {

                        svg {
                            height: 5rem;
                            width: 5rem;
                        }
                    }

                    & > a {
                        font-size: var(--small-size);
                    }
                }
            }
        }
    }
</style>
